import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex box-210 stepBoxCount" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]

import i18n from "@/core/i18n/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'RouterStepBox',
  props: {
    listIndex: {},
    step: {},
    index: {},
    openRouterSettings: {}
  },
  emits: [
  "set-button-visible",
  "set-button-invisible",
  "remove-step",
  "insert-at-index",
  "close-router",
],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global;

const props = __props;
const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "card border-0 border-radius-12 square-div-120 bg-purple router-section router-step",
      id: `router${_ctx.listIndex}`,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openRouterSettings(props.step, props.index, props.listIndex)))
    }, [
      _createElementVNode("div", {
        class: "d-flex flex-column align-items-center justify-content-center height-100 router-step",
        id: `router-unique-${_ctx.step.uniqueId}`
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "plus" }),
        _createTextVNode(" " + _toDisplayString(_unref(t)("Common.AddCondition")), 1)
      ], 8, _hoisted_3)
    ], 8, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(["col parent", { 'buttons-visible': true }]),
      onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (emit('set-button-visible', 1))),
      onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (emit('set-button-invisible')))
    }, [
      _createElementVNode("div", {
        class: "d-flex flex-column justify-content-center align-items-center child child-2",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('insert-at-index', props.index + 1, _ctx.step.ix))),
        style: {"transform":"translateY(-10px)"},
        id: "flow-add-step"
      }, [
        _createElementVNode("div", null, [
          _createVNode(_component_font_awesome_icon, { icon: "plus" })
        ])
      ])
    ], 32)
  ]))
}
}

})